import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import {createStore, applyMiddleware} from 'redux'
import thunk from "redux-thunk";
import reducer from './redux/reducer.js'
import './assets/fonts/avenir-lt-65-medium.ttf';

const store = createStore(reducer, applyMiddleware(thunk));

console.disableYellowBox = true;


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
